module.exports = __webpack_public_path__ + "img/skinbox.4b24ff0e.png";